export default function flatmap(property, callback) {
  property.properties &&
    property.properties.forEach(childProperty => {
      callback(childProperty, property);
      flatmap(childProperty, callback);
    });
}
